import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Button from '../CustomButton/CustomButton';
import language from '../../config/es';
import { es_vacio } from '../../config/validate';

// Verifica si la respuesta de getPermissions concede el acceso
export const isAllowed = (res) =>
  res.response === undefined && res.data.allow === true;

// Accion de permiso para guardar: agregar si es nuevo, editar si existe
export const saveActionOf = (data) =>
  data.id === null ? data.action.add : data.action.edit;

// Registra un error de validacion en el campo indicado
export const addFieldError = (data, key, message, errorKey = key) => {
  data.errors.push(errorKey + '.error');
  data[key].error = message;
};

// Valida que los campos indicados tengan valor
export const requireValues = (
  data,
  keys,
  message = language.messages.warning_required_field
) => {
  keys.forEach((key) => {
    if (es_vacio(data[key].value)) addFieldError(data, key, message);
  });
};

// Valida que los campos de seleccion tengan una opcion elegida
export const requireSelection = (
  data,
  keys,
  message = language.messages.error_no_selected
) => {
  keys.forEach((key) => {
    if (data[key].value === 0) addFieldError(data, key, message);
  });
};

// Lista de ids para dar de baja, con datos adicionales por registro
export const toIdList = (rows, extra = {}) =>
  rows.map((element) => ({ id: element.id, ...extra }));

// Asigna los campos indicados a cada fila seleccionada
export const stampRows = (rows, fields) => {
  rows.forEach((element) => {
    Object.assign(element, fields);
  });
};

// Ejecuta la consulta de filas; ante error notifica y devuelve lista vacia
export const fetchRows = async (request, notify) => {
  try {
    const rows = await request();
    if (rows.code !== undefined) {
      notify(rows.message, 'error');
      return [];
    }
    return rows;
  } catch (err) {
    console.error(err);
    return [];
  }
};

// Envuelve un campo en Col y/o Row segun se requiera
export const wrapField = (content, col, row) => {
  const inCol = col ? <Col {...col}>{content}</Col> : content;
  return row ? <Row>{inCol}</Row> : inCol;
};

// Columna de edicion para DataTable (fabrica a nivel de modulo)
export const buildEditColumn = (onEdit, { name = '', width, idKey = 'id' } = {}) => ({
  name,
  cell: (row) => (
    <button
      className="btn-fill btn btn-xs  btn-primary"
      type="button"
      onClick={() => {
        onEdit(row);
      }}
      id={row[idKey]}
    >
      <i className="fa fa-pencil"></i>
    </button>
  ),
  ignoreRowClick: true,
  allowOverflow: true,
  button: true,
  width,
});

// Boton de baja para las acciones contextuales del DataTable
export const renderDeleteAction = (
  onClick,
  enable,
  label = language.messages.btnDisable
) => (
  <Button
    key="delete"
    onClick={onClick}
    className="btn btn-danger-up"
    type="button"
    disabled={!enable}
  >
    {' '}
    <i className="fa fa-trash"></i>
    {label}
  </Button>
);

// Estado base compartido por los formularios de tipos/configuracion
export const createFormState = ({
  editTransaction = false,
  pendingData = false,
} = {}) => ({
  rolId: 0,
  idMenuEdit: 0,
  transactionEdit: [],
  responseDelete: [],
  newNameTransaction: '',
  editTransaction,
  addTransaction: !editTransaction,
  editType: true,
  enable: true,
  showloading: false,
  transactionsNotAssigned: [],
  tranNotAssigned: { value: 0, label: '' },
  transactions: [],
  columnsTransaction: [],
  params: [],
  columns: [],
  selectedRows: [],
  showDelete: false,
  pendingData,
  nameError: '',
  valueError: '',
  nombreTipo: '',
  codigoTipo: '',
  errors: [],
});
